import Navigation from './modules/navigation';
import Imax from './modules/imax';
import BakeryCarousel from './modules/bakery-carousel';
import Testimonials from './modules/testimonials';
import vendorCarousel from './modules/vendors';
import BreadModal from './modules/bread-modal';
import Rotator from './modules/rotator';
import SidebarLightbox from './modules/sidebar-lightbox';

import ContactMap from './modules/contact-map';
import LocationsMap from './modules/locations-map';

Imax.init();
BakeryCarousel.init();
Testimonials.init();

// initiate modules that bind after content load
window.addEventListener('DOMContentLoaded', e => {
	Navigation.init();
	SidebarLightbox.init();

	document.querySelector('body').classList.add('loaded');

	if(document.querySelector('.rotator')) Rotator.init();
});

window.initContactMap = () => ContactMap.init();
window.initLocationsMap = () => LocationsMap.$mount('#locations');
